import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app';
import { PATH_SIGN_UP } from '../common/constants/paths';

export default defineNuxtRouteMiddleware(() => {
  const { data } = useAuth();
  const $auth = data.value ?? null;

  if (!$auth) {
    return;
  }

  if ($auth.approved) {
    return navigateTo({ path: PATH_SIGN_UP });
  }
});
